import { mapWorkgroupPreviewFields } from '@/adapters/workgroups'
import { directusClient, imageFields, readItems } from '@/shared/utils/directus'

export default async function getWorkgroups({ locale = 'ru-RU' }: { locale?: string } = {}) {
  const collectionName = 'workgroups'

  const filter = {
    translations: { languages_code: { _eq: locale } },
  }

  try {
    const itemsRaw = await directusClient.request<Directus.WorkgroupPreview[]>(
      readItems(collectionName, {
        sort: ['sort', 'name'],
        filter,
        deep: {
          translations: { _filter: { languages_code: { _eq: locale } } },
          chief: { translations: { _filter: { languages_code: { _eq: locale } } } },
        },
        fields: [
          'id',
          'slug',
          {
            translations: ['name'],
            chief: ['id', { translations: ['name', 'position'], image: imageFields }],
            image: imageFields,
          },
        ],
      })
    )

    const items = itemsRaw?.map(item => {
      return mapWorkgroupPreviewFields(item)
    })

    return items
  } catch (error) {
    return []
  }
}
